import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dPosition", "d30Position", "d60Position", "riskAssessmentPosition", "clientSelect"]

  connect() {
    console.log('ClientRiskDecisionRuleFormController conectado')

    // Encontrar o select do cliente
    const clientSelect = this.element.querySelector('select[name*="client_id"]')
    if (clientSelect) {
      console.log('Select do cliente encontrado:', clientSelect)

      // Escutar eventos do select2
      $(clientSelect).on('select2:select', (e) => {
        console.log('Select2:select disparado')
        this.loadOptionsFromSelect(e.target)
      })

      $(clientSelect).on('select2:clear', () => {
        console.log('Select2:clear disparado')
        this.clearAllOptions()
      })

      // Se já houver um valor selecionado ao carregar, carregar as opções
      if (clientSelect.value) {
        console.log('Valor inicial encontrado:', clientSelect.value)
        this.loadOptionsFromSelect(clientSelect)
      }
    } else {
      console.log('Select do cliente não encontrado')
    }
  }

  loadOptions(event) {
    console.log('loadOptions chamado via evento change')
    this.loadOptionsFromSelect(event.target)
  }

  loadOptionsFromSelect(clientSelect) {
    const clientId = clientSelect.value

    console.log('Cliente selecionado:', clientId)

    if (!clientId) {
      console.log('Nenhum cliente selecionado, limpando opções')
      this.clearAllOptions()
      return
    }

    // Obter o locale da URL atual
    const pathParts = window.location.pathname.split('/')
    const locale = pathParts[1] || 'pt-BR'

    console.log('Fazendo fetch para:', `/${locale}/client_risk_decision_rules/load_options?client_id=${clientId}`)

    // Buscar as opções para este cliente
    fetch(`/${locale}/client_risk_decision_rules/load_options?client_id=${clientId}`, {
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then(data => {
        console.log('Opções carregadas:', data)
        this.updateBucketOptions(data.bucket_options)
        this.updateRiskAssessmentOptions(data.risk_assessment_options)
      })
      .catch(error => {
        console.error('Erro ao carregar opções:', error)
        this.clearAllOptions()

        // Mostrar mensagem de erro para o usuário
        if (window.Swal) {
          window.Swal.fire({
            title: 'Erro',
            text: 'Não foi possível carregar as opções. Por favor, tente novamente.',
            icon: 'error'
          })
        }
      })
  }

  updateBucketOptions(options) {
    // Atualizar d_position
    if (this.hasDPositionTarget) {
      const $dPosition = $(this.dPositionTarget)
      const currentValue = $dPosition.val()
      const placeholder = $dPosition.find('option[value=""]').text() || 'Selecione um bucket'

      let html = `<option value="">${placeholder}</option>`
      options.forEach(opt => {
        const selected = opt.value.toString() === currentValue ? 'selected' : ''
        html += `<option value="${opt.value}" ${selected}>${opt.label}</option>`
      })

      $dPosition.html(html)
      $dPosition.trigger('change')
    }

    // Atualizar d30_position
    if (this.hasD30PositionTarget) {
      const $d30Position = $(this.d30PositionTarget)
      const currentValue = $d30Position.val()
      const placeholder = $d30Position.find('option[value=""]').text() || 'Selecione um bucket (opcional)'

      let html = `<option value="">${placeholder}</option>`
      options.forEach(opt => {
        const selected = opt.value.toString() === currentValue ? 'selected' : ''
        html += `<option value="${opt.value}" ${selected}>${opt.label}</option>`
      })

      $d30Position.html(html)
      $d30Position.trigger('change')
    }

    // Atualizar d60_position
    if (this.hasD60PositionTarget) {
      const $d60Position = $(this.d60PositionTarget)
      const currentValue = $d60Position.val()
      const placeholder = $d60Position.find('option[value=""]').text() || 'Selecione um bucket (opcional)'

      let html = `<option value="">${placeholder}</option>`
      options.forEach(opt => {
        const selected = opt.value.toString() === currentValue ? 'selected' : ''
        html += `<option value="${opt.value}" ${selected}>${opt.label}</option>`
      })

      $d60Position.html(html)
      $d60Position.trigger('change')
    }
  }

  updateRiskAssessmentOptions(options) {
    if (this.hasRiskAssessmentPositionTarget) {
      const $riskAssessment = $(this.riskAssessmentPositionTarget)
      const currentValue = $riskAssessment.val()
      const placeholder = $riskAssessment.find('option[value=""]').text() || 'Selecione um nível de risco'

      let html = `<option value="">${placeholder}</option>`
      options.forEach(opt => {
        const selected = opt.value.toString() === currentValue ? 'selected' : ''
        html += `<option value="${opt.value}" ${selected}>${opt.label}</option>`
      })

      $riskAssessment.html(html)
      $riskAssessment.trigger('change')
    }
  }

  clearAllOptions() {
    // Limpar bucket options
    if (this.hasDPositionTarget) {
      const $dPosition = $(this.dPositionTarget)
      const placeholder = $dPosition.find('option[value=""]').text() || 'Selecione um bucket'
      $dPosition.html(`<option value="">${placeholder}</option>`)
      $dPosition.trigger('change')
    }

    if (this.hasD30PositionTarget) {
      const $d30Position = $(this.d30PositionTarget)
      const placeholder = $d30Position.find('option[value=""]').text() || 'Selecione um bucket (opcional)'
      $d30Position.html(`<option value="">${placeholder}</option>`)
      $d30Position.trigger('change')
    }

    if (this.hasD60PositionTarget) {
      const $d60Position = $(this.d60PositionTarget)
      const placeholder = $d60Position.find('option[value=""]').text() || 'Selecione um bucket (opcional)'
      $d60Position.html(`<option value="">${placeholder}</option>`)
      $d60Position.trigger('change')
    }

    // Limpar risk assessment options
    if (this.hasRiskAssessmentPositionTarget) {
      const $riskAssessment = $(this.riskAssessmentPositionTarget)
      const placeholder = $riskAssessment.find('option[value=""]').text() || 'Selecione um nível de risco'
      $riskAssessment.html(`<option value="">${placeholder}</option>`)
      $riskAssessment.trigger('change')
    }
  }
}
